var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSwapIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icn-button-active"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.79981 11.0234C6.18464 11.6131 5.36965 11.9357 4.50209 11.9357L4.50075 11.9357C2.70645 11.9357 1.25 10.5357 1.25 8.81957V4.1939C1.25 3.48073 1.85205 2.90361 2.59604 2.90361C3.34003 2.90361 3.94207 3.48073 3.94207 4.1939V8.81957C3.94207 9.11696 4.19447 9.35511 4.50075 9.35511C4.64929 9.35511 4.79126 9.29714 4.8951 9.1976L14.0953 0.378499C14.6198 -0.124261 15.4755 -0.128068 16 0.378499C16.5245 0.885065 16.5245 1.70156 16 2.20432L6.79981 11.0234ZM4.00131 17.7962L13.2015 8.97706C13.8166 8.38737 14.6316 8.0648 15.4992 8.0648C17.2935 8.0648 18.7499 9.46473 18.7499 11.1809V15.8066C18.7499 16.5198 18.1479 17.0969 17.4039 17.0969C16.6599 17.0969 16.0579 16.5198 16.0579 15.8066V11.1809C16.0579 10.8835 15.8055 10.6454 15.4992 10.6454C15.3506 10.6454 15.2087 10.7033 15.1048 10.8029L5.90468 19.622C5.64311 19.874 5.3 20 4.95299 20C4.6073 20 4.26421 19.874 4.00131 19.622C3.47683 19.1154 3.47683 18.2989 4.00131 17.7962Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwapIcon);
export default __webpack_public_path__ + "static/media/swap_icon.de196df4cecb8c46d9a424c955c84168.svg";
export { ForwardRef as ReactComponent };